import jsPDF from 'jspdf';
import moment from 'moment';
import { Comment } from 'redux/conductInspectionSlice';
import { Team } from 'redux/projectSlice';
import Logo from 'assets/images/logo.png';
import {
  addBorderAndFooter,
  addImageWithUrl,
  addNewPage,
  addText,
  addTitle,
  addTwoText,
} from 'helper/download';
import { IObservationsReport } from 'redux/services/observation';

export const downloadObservationReport = (
  report: IObservationsReport,
  team: Team[],
) => {
  const pdf = new jsPDF({ compress: true });
  const x = 25;

  const { observationsInfo, projectInfo, tasks } = report;

  addBorderAndFooter(pdf);
  pdf.setFontSize(12);
  pdf.setTextColor('#000');
  pdf
    .setFont(undefined as any, 'bold')
    .text('Project Name -', x, 20)
    .setFont(undefined as any, 'normal')
    .text(`${projectInfo.projectName}`, x + 32, 20)
    .setFont(undefined as any, 'bold')
    .text('Project Id -', x, 28)
    .setFont(undefined as any, 'normal')
    .text(`${projectInfo.projectDisplayId}`, x + 23, 28)
    .setFont(undefined as any, 'bold')
    .text('Observation Report - ', x, 36)
    .setFont(undefined as any, 'normal')
    .text(`${observationsInfo.displayId}`, x + 45, 36)
    .setFont(undefined as any, 'bold')
    .text('Report Date - ', x, 44)
    .setFont(undefined as any, 'normal')
    .text(`${moment().format('DD-MM-yyyy')}`, x + 28, 44)
    .addImage(Logo, 130, 20, 55, 20);
  pdf.line(x, 50, 185, 50);

  addTitle(pdf, 'SUMMARY', x, 60);

  let py = 70;

  py = addTwoText(
    pdf,
    x,
    py,
    'Sub Projects -',
    Object.values({
      subProject: observationsInfo.subProject?.name ?? '',
      subTask: observationsInfo.subTask?.name ?? '',
      endTask: observationsInfo.endTask?.name ?? '',
    })
      .filter((value) => value)
      .join(' -> '),
  );

  py = addTwoText(
    pdf,
    x,
    py,
    'Area of Observation -',
    observationsInfo.observationInfo?.areaOfObservations ?? '',
  );

  py = addTwoText(
    pdf,
    x,
    py,
    'Tags -',
    observationsInfo.observationInfo?.locations?.join(', ') ?? '',
  );
  py = addTwoText(
    pdf,
    x,
    py,
    'Observation Date -',
    moment(
      observationsInfo.observationDate ?? observationsInfo.updated_at,
    ).format('DD-MM-yyyy'),
  );
  py = addTwoText(pdf, x, py, 'Observation Raised By -', '');
  py = addTwoText(
    pdf,
    x,
    py,
    'Description -',
    observationsInfo.observationInfo?.description ?? 'N/A',
  );
  py = addTwoText(
    pdf,
    x,
    py,
    'Observation Type -',
    observationsInfo.observationInfo?.observationType ?? 'N/A',
  );
  py = addTwoText(pdf, x, py, 'Observation Status -', observationsInfo.status);
  py = addTwoText(
    pdf,
    x,
    py,
    'Doer -',
    team?.find((t) => t.userId === observationsInfo.doer)?.name ?? '',
  );

  tasks.forEach((task, i) => {
    py = addTwoText(pdf, x, py, `Current Action Status -`, task.status);
    py = addTwoText(pdf, x, py, `Last Action By -`, task.updatedBy);
    py = addTwoText(pdf, x, py, `Task Pending With -`, '');
    py += 2;
  });

  pdf.setFont(undefined as any, 'bold');

  pdf.setFontSize(9);

  py = addText(pdf, x, py + 5, 'Attachment with this report', true);
  pdf.setFontSize(8);
  py = addText(pdf, x + 10, py - 5, ' \u2022  Task History', true);
  py = addText(pdf, x + 10, py - 5, ' \u2022  Photos', true);

  pdf.setFontSize(12);

  pdf.setFont(undefined as any, 'normal');

  addNewPage(pdf);

  let y = 20;

  addTitle(pdf, 'TASK HISTORY');

  y += 10;

  pdf.setFontSize(12);
  pdf.setTextColor('#000');

  if ((observationsInfo?.observationInfo?.images.length ?? 0) > 0) {
    const { observationInfo } = observationsInfo;

    for (let im = 0; im < observationInfo!.images!.length; im++) {
      y = addImageWithUrl(
        pdf,
        x,
        y,
        observationInfo!.images![im].url,
        'Attachment:',
      );
    }
  }

  if (tasks?.length > 0) {
    tasks.forEach((task) => {
      y = addTwoText(pdf, x, y, 'Task Name -', task.name);

      pdf.setFont(undefined as any, 'bold');
      pdf.setFont(undefined as any, 'normal');

      y = addTwoText(pdf, x, y, 'Current Status -', task.status);

      task.comments?.forEach((comment, i) => {
        y = addTwoText(pdf, x, y, 'Message: ', comment.comment);
        y = addTwoText(
          pdf,
          x,
          y,
          'Action Taken -',
          (comment as Comment).action?.split('_').join(' ') ?? 'N/A',
        );
        y = addTwoText(
          pdf,
          x,
          y,
          'Action Taken By -',
          team.find((t) => t.userId === (comment as Comment).senderId)?.name ??
            '',
        );
        y = addTwoText(
          pdf,
          x,
          y,
          'Comment Date -',
          moment(moment((comment as Comment).commentedAt).toISOString()).format(
            'DD-MM-YYYY',
          ),
        );

        if (comment.documents?.length > 0) {
          y = addImageWithUrl(
            pdf,
            x,
            y,
            comment.documents?.[0].url,
            'Attachment:',
          );
        }

        if (i < task.comments.length - 1) {
          pdf.line(x, y - 5, 180, y - 5);
        }
      });

      y = y + 5;
    });
  } else {
    pdf.text('No Tags were raised!', x, y);
  }

  pdf.save(
    `Observation Report - ${observationsInfo.displayId}-${moment(
      observationsInfo.updated_at,
    ).format('DD-MM-YYYY')}`,
  );
};
